import React from 'react'
import { Info } from 'lucide-react'
import { Label } from '@/components/ui/label'
import { cn } from '@/utilities/ui'

export interface FormLabelProps {
  /** Associates the label to an input id */
  htmlFor: string
  /** Optional id for aria-labelledby and targeting */
  id?: string
  /** Label contents */
  children: React.ReactNode

  /** Visual styles */
  className?: string

  /** Required indicator */
  required?: boolean
  requiredIndicator?: React.ReactNode
  requiredIndicatorClassName?: string

  /** Optional info icon */
  showInfoIcon?: boolean
  infoIcon?: React.ReactNode
  infoIconClassName?: string
}

export function FormLabel({
  htmlFor,
  id,
  children,
  className = '',
  required = false,
  requiredIndicator,
  requiredIndicatorClassName,
  showInfoIcon = false,
  infoIcon,
  infoIconClassName,
}: Readonly<FormLabelProps>) {
  const resolvedInfoIconClassName = infoIconClassName || 'inline-block w-4 h-4 ml-2'
  const resolvedRequiredIndicatorClassName = requiredIndicatorClassName || 'text-required ml-1'

  return (
    <Label htmlFor={htmlFor} id={id} className={className} data-testid="form-label">
      {children}

      {required &&
        (requiredIndicator ?? (
          <span className={cn(resolvedRequiredIndicatorClassName)} aria-hidden="true">
            *
          </span>
        ))}

      {showInfoIcon &&
        (infoIcon ?? (
          <Info
            className={cn('text-tenant-primary-action-color', resolvedInfoIconClassName)}
            aria-hidden="true"
          />
        ))}
    </Label>
  )
}
